import { createSlice } from '@reduxjs/toolkit';
import { stateName } from './constants';
const initialUiState = {
  currentPromotion: null
};
export const initialState = {
  uploadedItem: {
    id: null,
    pushedUpId: null,
    feedbackItemId: null
  },
  promotedItemId: null,
  ui: initialUiState
};

const setUploadedItemId = (draft, action) => {
  const {
    id
  } = action.payload;
  draft.uploadedItem.id = id;
};

const setUploadedItemPushedUpId = (draft, action) => {
  const {
    id
  } = action.payload;
  draft.uploadedItem.pushedUpId = id;
};

const setFeedbackItemId = (draft, action) => {
  const {
    id
  } = action.payload;
  draft.uploadedItem.feedbackItemId = id;
};

const setPromotedItemId = (draft, action) => {
  const {
    id
  } = action.payload;
  draft.promotedItemId = id;
};

const setCurrentPromotionAfterItemUpload = (draft, action) => {
  const {
    promo
  } = action.payload;
  draft.ui.currentPromotion = promo;
};

const profileSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setFeedbackItemId,
    setUploadedItemId,
    setPromotedItemId,
    setUploadedItemPushedUpId,
    setCurrentPromotionAfterItemUpload
  }
});
export const {
  actions
} = profileSlice;
export const plug = {
  [stateName]: profileSlice.reducer
};
export default profileSlice.reducer;